import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useState } from "react";

function DialogParcialProtestada({ close, aceiteProtestoParcial }) {
  const [checkedProtestoParcial, setCheckedProtestoParcial] = useState(false);
  const [emailConfirmacao, setEmailConfirmacao] = useState("");

  function dialogProtestoFooter() {
    return (
      <div className="mt-[2vh] grid gap-[5vh] font-lato">
        <div className="continueButton w-full grid px-[20%]">
          <Button
            className="continueButton w-3/4"
            onClick={() => aceiteProtestoParcial(emailConfirmacao)}
            label="Aceito"
            disabled={!checkedProtestoParcial || emailConfirmacao === ""}
          ></Button>
        </div>
      </div>
    );
  }

  return (
    <Dialog
      header="Negociação Parcial com protesto"
      draggable={false}
      className="boletosDialog card"
      onHide={() => close()}
      visible
      footer={dialogProtestoFooter}
      style={{
        maxWidth: window.innerWidth > 760 ? "60vw" : "100vw",
        minHeigth: "30vh",
        minWidth: "20vh",
        textAlign: "center",
        // borderRadius: '30px',
        // padding: '10px'
      }}
    >
      <div className="font-lato">
        <h6 className="p-5 text-slate-700 ">
          Você possui débitos protestados, para sair do protesto é necessário realizar uma negociação total, ao negociar
          os débitos selecionados para negociação parcial, você assume estar ciente de que o pagamento da negociação
          gerada apenas com estes não implicará em reversão do protesto realizado
        </h6>
        <div className="grid p-fluid mt-3 py-[2vh] lg:px-[10%]">
          <span className="p-float-label">
            <InputText
              value={emailConfirmacao}
              onChange={(e) => setEmailConfirmacao(e.target.value)}
              id="email"
              type="email"
            ></InputText>
            <label htmlFor="email">Por favor confirmar seu email</label>
          </span>
        </div>
        <div className="loginCheckbox" style={{ textAlign: "center" }}>
          <Checkbox
            inputId="binary"
            className="loginCheckbox pb-5"
            checked={checkedProtestoParcial}
            onChange={(e) => setCheckedProtestoParcial(e.checked)}
          />
          <label htmlFor="binary" className="text-[2vh]">
            Estou ciente de que a negociação e pagamento dos débitos selecionados não implica em reversão do protesto.
          </label>
        </div>
      </div>
    </Dialog>
  );
}

export default DialogParcialProtestada;
